import { MutationTree } from "vuex";
import { IUserProfileState, getDefaultUserState } from ".";
import { IUser } from "@/models/user";

export const mutations: MutationTree<IUserProfileState> = {
    setUserInfo(state, payload: IUser) {
        state.error = null;
        state.userInfo = { ...payload };
        state.isAutehnticated = !!payload;
    },
    setUserError(state, payload: any) {
        state.error = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultUserState());
    },
};
